import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PatientService } from '../../shared';

@Component({
  selector: 'app-confirmtemp',
  templateUrl: './confirmtemp.component.html',
  styleUrls: ['./confirmtemp.component.css']
})
export class ConfirmtempComponent implements OnInit {
  @Input() catId: any;
  @Input() patact: any;
  @Input() patSurveyId: number;
  @Input() clientId: number;
  @Input() loginUserId: number;
  constructor(public dialogRef: MatDialogRef<ConfirmtempComponent>, public router: Router, public patientService: PatientService, private toast: ToastrService) {
    //////console.log("hello")
  }

  remainder: any = false;
  //timealert:any = environment.timelimit
  ngOnInit() {
  }
  sendRemainder() {
    this.remainder = true;
    this.patientService.getProMailContent(this.patSurveyId, this.clientId)
      .subscribe(
        data => {
          if (data.message) {
            this.notes = data.message
          }
        }
      );

  }
  onYesClick(): void {
    return this.dialogRef.close('yes');
  }
  onNoClick(): void {
    if (this.notes && this.remainder) {
      let message = {
        status: '',
        message: this.notes
      }
      this.patientService.sendProMailReminder(this.patSurveyId, this.clientId, this.loginUserId, message)
        .subscribe(
          data => {

            this.toast.success(data.message, '', {
              timeOut: 3000
            });
          }
        );
    }
    this.dialogRef.close('no');
    this.router.navigateByUrl('/care/patientsummary')
  }
  notes: any = ''
  textvar: any = `Enter your message...`
}
